<template>
  <section v-if="list.length" v-auto-animate class="bg-ambi-red text-white py-2.5">
    <div v-for="{ message, id } in list" :key="id" class="Notification">
      <div class="Container">
        <div class="Row">
          <div class="Col w-full text-center">
            <notification-message
              :message="message"
              :id="id"
              @on-delete-notification="removeNotification"
              class="flex justify-between px-5 items-baseline py-1"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const STORE_KEY = 'dk.notifications'

export default {
  props: {
    controlName: {
      type: String,
      required: true
    },
    flashes: {
      type: Object
    },
    notifications: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'compact' /* compact, snug */
    },
    container: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      notificationsLocal: [...this.notifications]
    }
  },
  methods: {
    removeNotification(id) {
      this.notificationsLocal = this.notificationsLocal.filter(
        notification => notification.id !== id
      )
      this.setStoredNotification(id)
    },
    getStoredNotifications() {
      let stored = localStorage.getItem(STORE_KEY)
      if (!stored) {
        stored = []
      } else {
        stored = JSON.parse(stored)
      }

      return stored
    },
    setStoredNotification(notificationId) {
      let store = this.getStoredNotifications()
      store.push(notificationId)
      localStorage.setItem(STORE_KEY, JSON.stringify(store))
    }
  },
  computed: {
    list() {
      let store = this.getStoredNotifications()

      return this.notificationsLocal.filter(notification => !store.includes(notification.id))
    }
  }
}
</script>
